import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-field',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss'],
})
export class DeleteFormFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
